;(function(factory) {
    // conditional factory logic should be placed here.
   if (typeof Lum == 'undefined' || typeof jQuery == 'undefined') {
       var lmnInterval = setInterval(function(){
           if (typeof Lum != 'undefined' && typeof jQuery != 'undefined') {
               clearInterval(lmnInterval);
               factory(jQuery);
           }
       }, 100);
   } else {
       factory(jQuery);
   }
})(function($) {
    
    /**
     * This is the default duration in days for cookies.
     * To set no expire time set this attribute to 0.
     * 
     * @type {Number}
     */
    var epireLifeTime = 0;

    /**
     * This function calculates the expire date of the cookie.
     * Set the parameter 0 to keep alive for indeterminate period and -1 to invalidate the cookie.
     * 
     * @param  {Integer} days The number of days to keep the cookie alive. 
     * @return {String}       The expire date of the cookie.
     */
    var getExpireDate = function (days) {
        if (!days || days == '0') {
            return '';
        }

        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        return "expires=" + date.toUTCString() + ';';
    };

    /**
     * Given a key, a value, and the days, this function sets the cookie in the browser.
     * 
     * @param  {String}  key   The key to denote the cookie. 
     * @param  {String}  value The value to set the cookie to.
     * @param  {Integer} days  The number of days to keep the cookie alive. 
     */
    var addCookie = function(key, value, days) {
        days = days || epireLifeTime;

        var expires = getExpireDate(days);
        document.cookie = key + "=" + value + ";" + expires + " path=/";
    };

    /**
     * Given a key and a default value, returns the cookie value of that key or the default value.
     * 
     * @param  {String}  key      The cookie to retrive. 
     * @param  {String}  defVal   The default value in case cookie doesn't exist. 
     * @return {String}           The expire date of the cookie.
     */
    var getCookie = function(key, defVal) {
        defVal = defVal || "";
        
        var name = key + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return defVal;
    };

    /**
     * Given a cookie key or name, this function deletes it setting the expire date to -1.
     * 
     * @param  {String}  key      The cookie to retrive. 
     */
    var deleteCookie = function(key) {
        addCookie(key, "", -1);
    };

    /**
    * Keep the file versioned.
    * @return {String}
    */
    var version = function () {
        return '1.0.0';
    };

    window.Lum.Cookie = {
        add: function (key, value, time) {
            addCookie(key, value, time)
        },
        set: function (key, value, time) {
            addCookie(key, value, time)
        },
        get: function (key) {
            return getCookie(key);
        },
        delete: function (key, defVal) {
            deleteCookie(key, defVal);
        },
        version: function () {
            return varsion();
        }
    };

});